export default {"src":"/_next/static/media/interestRate.06458bd3.svg","height":105,"width":116};